import Joi from 'joi-browser';

export default {
  tooltipId: Joi.string(),
  text: Joi.string(),
  label: Joi.string()
};
